export default "__VITE_ASSET__BzOvL6d6__"